import { applyHousekeepingWrite as e } from "./invalidateHousekeeping.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { housekeepingApi as r } from "@maat/api-main";
//#region src/housekeeping/useInspectRoomMutation.ts
var i = (i) => {
	let a = n();
	return t({
		mutationFn: ({ unitId: e }) => r.inspectRoom(i, e),
		onSuccess: (t) => e(a, i, [t])
	});
};
//#endregion
export { i as useInspectRoomMutation };
